import React from 'react';
import Select from 'react-select';

const TimezoneSelect = ({selectedTimezone, handleChange}) => {
  // value should be a valid PHP supported timezone:
  // https://www.php.net/manual/en/timezones.php
  const timezoneOptions = [
    {
      label: 'Eastern Time',
      value: 'America/New_York'
    },
    {
      label: 'Pacific Time',
      value: 'America/Los_Angeles'
    },
    {
      label: 'Central Time',
      value: 'America/Chicago'
    },
    {
      label: 'Mountain Time',
      value: 'America/Denver'
    }
  ];

  return (
    timezoneOptions && <Select
      onChange={(obj) => {
        handleChange(obj.value);
      }}
      value={timezoneOptions.filter(item => item.value === selectedTimezone)}
      getOptionLabel={(a) => a.label}
      getOptionValue={(a) => a.value}
      options={timezoneOptions}
    />
  );
};

export default TimezoneSelect;